import { AnimatedSection } from "./AnimatedSection";
import { Shield } from "lucide-react";

export function Authority() {
  return (
    <section className="py-24 md:py-32 bg-[#09120D]" data-testid="authority-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <AnimatedSection>
            <p className="text-[#22C55E] text-sm font-medium tracking-widest uppercase mb-4">
              Authority
            </p>
            <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
              Built by operators, not observers
            </h2>
            <p className="mt-8 text-[#A1B2A8] text-base lg:text-lg leading-relaxed">
              Delta GreenX is designed by professionals with real experience in pricing, supply chains, and global trade execution.
            </p>
          </AnimatedSection>

          <AnimatedSection delay={0.15}>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-[#050A07] border border-[#1A2E22] p-8 text-center hover:border-[#22C55E]/50 transition-colors duration-300">
                <Shield className="w-6 h-6 text-[#22C55E] mx-auto mb-3" />
                <p className="text-white font-['Outfit'] font-semibold text-sm">Verified Participants</p>
              </div>
              <div className="bg-[#050A07] border border-[#1A2E22] p-8 text-center hover:border-[#22C55E]/50 transition-colors duration-300">
                <Shield className="w-6 h-6 text-[#22C55E] mx-auto mb-3" />
                <p className="text-white font-['Outfit'] font-semibold text-sm">Structured Pricing</p>
              </div>
              <div className="bg-[#050A07] border border-[#1A2E22] p-8 text-center hover:border-[#22C55E]/50 transition-colors duration-300">
                <Shield className="w-6 h-6 text-[#22C55E] mx-auto mb-3" />
                <p className="text-white font-['Outfit'] font-semibold text-sm">Controlled Access</p>
              </div>
              <div className="bg-[#050A07] border border-[#1A2E22] p-8 text-center hover:border-[#22C55E]/50 transition-colors duration-300">
                <Shield className="w-6 h-6 text-[#22C55E] mx-auto mb-3" />
                <p className="text-white font-['Outfit'] font-semibold text-sm">Trade Expertise</p>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
